import type {
  Graph3DEdgeRendererRegistry,
  Graph3DNodeRendererRegistry,
} from '../core/renderer.types';
import { EdgeTube3D } from './edges/EdgeTube3D';
import { FlowEdge3D } from './edges/FlowEdge3D';
import { AvatarNode3D } from './nodes/AvatarNode3D';
import { BadgeNode3D } from './nodes/BadgeNode3D';
import { CardNode3D } from './nodes/CardNode3D';
import { OrgUnitNode3D } from './nodes/OrgUnitNode3D';
import { ProcessNode3D } from './nodes/ProcessNode3D';

export const defaultNodeRenderers: Graph3DNodeRendererRegistry = {
  default: CardNode3D,
  card: CardNode3D,
  process: ProcessNode3D,
  result: BadgeNode3D,
  role: AvatarNode3D,
  company: OrgUnitNode3D,
  department: OrgUnitNode3D,
  person: AvatarNode3D,
};

export const defaultEdgeRenderers: Graph3DEdgeRendererRegistry = {
  default: EdgeTube3D,
  flow: FlowEdge3D,
  hierarchy: EdgeTube3D,
  dependency: EdgeTube3D,
};
